<template lang="pug">
  v-nav-tabs(
    :options="isMobile ? optionsMobile : options")
</template>

<script>
import { mapGetters } from 'vuex'

import { getFarmPath } from '@/util/app.js'
import navigationMixin from '@/mixins/navigation.mixin.js'
import adaptationMixin from '@/mixins/adaptation.mixin.js'

export default {
  name: 'ReportTabs',

  mixins: [navigationMixin, adaptationMixin],

  data: () => ({
    animalfeed: [
      { id: 0, title: 'base.fodder', path: 'reports/kkz' }
    ],
    profeed: [
      { id: 1, title: 'reports.mixer_loads', path: 'reports/mixer-loads' },
      { id: 2, title: 'reports.mixer_uploads', path: 'reports/mixer-uploads' },
      { id: 3, title: 'reports.plan_feed', path: 'reports/planfeed' },
      // { id: 4, title: 'reports.consumption_schedule', path: 'reports/consumption' }
    ]
  }),

  computed: {
    ...mapGetters('account', [
      'hasProfeed',
      'hasAnimalfeed'
    ]),

    options () {
      return this.filteredOptions
        .map((item) => ({
          id: item.id,
          title: item.title,
          path: getFarmPath(null, this.$route, item.path)
        }))
    },

    filteredOptions () {
      return [
        ...(this.hasAnimalfeed
          ? this.animalfeed
          : []),
        ...(this.hasProfeed
          ? this.profeed
          : [])
      ]
    },

    optionsMobile () {
      return this.options
        .filter(item => item.path.includes('reports/mixer-loads') ||
          item.path.includes('reports/mixer-uploads'))
    }
  }
}
</script>
